import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBedTypeById, updateBedType } from "adminApi/RoomSettingApi/RoomSetting";
import { validateForm } from "utils/validation";
import { BedListRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditBedForm from "./Componates/EditBed";
import fields from "../json/BedListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditBedType = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(
    initialValues,
    BedListRules
  );

  // Fetch existing record by ID and populate form
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getBedTypeById, setValues);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send plain JSON — no file uploads in this form
    async (formValues) => await updateBedType({ id, data: formValues }),
    (vals) => {
      const err = validateForm(vals, BedListRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Bed updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditBedForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Edit Bed"
      />
    </>
  );
};

export default EditBedType;
